import './bootstrap';

import { createApp } from 'vue';

import ConsentBanner from './components/ConsentBanner.vue';

const app = createApp({});

app.component('consent-banner', ConsentBanner);

app.mount('#app');
